<div class="metabase">
  <ng-container *ngIf="safeMetabaseUrl && !reloading">
    <iframe
      id="dashboardIframe"
      [src]="safeMetabaseUrl"
      frameborder="0"
      allowtransparency
      onload="iFrameResize({checkOrigin: false, bodyPadding: '0 16px', scrolling: true}, this);"
    ></iframe>
  </ng-container>

  <div *ngIf="loading; else locationPicker">
    <app-progress-spinner
      color="primary"
      [diameter]="32"
      style="
        position: absolute;
        top: 0;
        right: 50%;
        margin-left: auto;
        margin-top: 40px;
      "
    ></app-progress-spinner>
  </div>
  <ng-template #locationPicker>
    <app-form-field
      *ngIf="dashboard?.filter === 'location'"
      class="location-picker"
      appearance="outline"
      color="primary"
    >
      <app-label>Filtrar Unidade</app-label>
      <app-select
        [(value)]="selectedLocation"
        (selectionChange)="locationChanged($event.value)"
        panelClass="location-picker-option"
      >
        <app-option>Todas unidades</app-option>
        <app-option
          *ngFor="let location of (locations | async)?.locations"
          [value]="location"
        >
          {{ location.name || location.code }}
        </app-option>
      </app-select>
    </app-form-field>
  </ng-template>

  <app-progress-spinner
    *ngIf="reloading"
    color="primary"
    [diameter]="32"
    style="margin-left: auto; margin-right: auto; margin-top: 200px"
  ></app-progress-spinner>
</div>
